var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./HelpBahasaMalaysia.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-31f837f9\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./HelpBahasaMalaysia.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/about/HelpBahasaMalaysia.vue
// module id = 1075
// module chunks = 0